import NotFound from '../components/NotFound';

// import Home from '../components/Home';
// import Signin from '../components/Signin';
// import OrderMenu from '../components/orderMenu/OrderMenu';
// import OrderTab from '../components/order/OrderTab';
// import OrderHistory from '../components/order/OrderHistory';
// import InAppMsg from '../components/inAppMsg/InAppMsg';
// import Transactions from '../components/transactions/Transactions';
// import InstallWebapp from '../components/misc/InstallWebapp';
// import Settings from '../components/misc/Settings';
// import Profile from '../components/misc/Profile';
// import CardManager from '../components/cardManagement/CardManager';
// import OrderSuccess from '../components/order/OrderSuccess';
// import MerchantLocation from '../components/merchant/SelectLocation';
// import MerchantDelivery from '../components/merchant/SelectDelivery';

export const routes = [

    {
        path: '/m/merchants',
        component: NotFound,
        name: 'not-found',
        title: 'Not Found',
        onFooter: false,
        onOverflow: false,
        displaySequence: 1,
        icon: 'home'
    },
    // {
    //     path: '/about',
    //     name: 'about',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    // },
    {
        path: '/m/:slug',
        // name: 'merchant-home',
        mainRoute : true,
        title: 'Merchant Home',
        onFooter: false,
        onOverflow: false,
        displaySequence: 1,
        icon: 'home',
        props: true,
        component: () => import( '../components/MerchantHome' ),
        children : [

            {
                path: '',
                component: () => import( '../components/Home' ),
                name: 'home',
                title: 'Home',
                onFooter: true,
                onOverflow: false,
                displaySequence: 1,
                icon: 'home'
            },
            {
                path: 'identifying',
                component: () => import( '../components/merchant/IdentifyMerchant' ),
                name: 'identifying',
                title: 'Processing...',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null
            },
            {
                path: 'signin',
                component: () => import( '../components/Signin' ),
                name: 'signin',
                title: 'Signin',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null
            },
            {
                path: 'orderMenu',
                // component: OrderMenu,
                name: 'order-menu',
                title: 'Menu',
                onFooter: true,
                onOverflow: false,
                displaySequence: 2,
                icon: 'utensils',
                component: () => import( '../components/orderMenu/OrderMenu' ),
            },
            {
                path: 'orderTab',
                // component: OrderTab,
                name: 'order-tab',
                title: 'My Cart',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null,
                component: () => import( '../components/order/OrderTab' ),
            },
            {
                path: 'orderHistory',
                // component: OrderHistory,
                name: 'order-history',
                title: 'Order History',
                onFooter: true,
                onOverflow: false,
                displaySequence: 3,
                icon: 'history',
                component: () => import( '../components/order/OrderHistory' ),
            },
            {
                path: 'viewOrder',
                name: 'view-order',
                title: 'Viewing Order',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null,
                component: () => import( '../components/order/ViewOrder' ),
            },
            {
                path: 'inAppMsg',
                // component: InAppMsg,
                name: 'in-app-msg',
                title: 'Messages',
                onFooter: false,
                onOverflow: true,
                displaySequence: 3,
                icon: 'envelope',
                component: () => import( '../components/inAppMsg/InAppMsg' ),
            },
            {
                path: 'viewMsg',
                name: 'view-msg',
                title: 'Viewing Message',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null,
                component: () => import( '../components/inAppMsg/ViewMsg' ),
            },
            {
                path: 'transactions',
                // component: Transactions,
                name: 'transactions',
                title: 'Transactions',
                onFooter: false,
                onOverflow: true,
                displaySequence: 3,
                icon: 'heartbeat',
                component: () => import( '../components/transactions/Transactions' ),
            },
            {
                path: 'installWebapp',
                // component: InstallWebapp,
                name: 'install-webapp',
                title: 'Install App',
                onFooter: false,
                onOverflow: true,
                displaySequence: 4,
                icon: 'download',
                component: () => import( '../components/misc/InstallWebapp' ),
            },
            {
                path: 'settings',
                // component: Settings,
                name: 'settings',
                title: 'Settings',
                onFooter: false,
                onOverflow: false,
                displaySequence: 2,
                icon: 'cog',
                component: () => import( '../components/misc/Settings' ),
            },
            {
                path: 'profile',
                // component: Profile,
                name: 'profile',
                title: 'Profile',
                onFooter: false,
                onOverflow: true,
                displaySequence: 1,
                icon: 'user-circle',
                component: () => import( '../components/misc/Profile' ),
            },
            {
                path: 'manageCards',
                // component: CardManager,
                name: 'manage-cards',
                title: 'My Cards',
                onFooter: false,
                onOverflow: true,
                displaySequence: 2,
                icon: 'credit-card',
                component: () => import( '../components/cardManagement/CardManager' ),
            },
            {
                path: 'viewCard',
                name: 'view-card',
                title: 'Viewing Card',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null,
                component: () => import( '../components/cardManagement/ViewCard' ),
            },
            {
                path: 'orderSuccess',
                // component: OrderSuccess,
                name: 'order-success',
                title: '',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null,
                component: () => import( '../components/order/OrderSuccess' ),
            },
            {
                path: 'orderDeliveryFailure',
                name: 'order-delivery-failure',
                title: '',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null,
                component: () => import( '../components/order/OrderDeliveryFailure' ),
            },
            {
                path: 'orderDuplicateFailure',
                name: 'order-duplicate-failure',
                title: '',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null,
                component: () => import( '../components/order/OrderDuplicateFailure' ),
            },
            {
                path: 'merchantLocation',
                // component: MerchantLocation,
                name: 'merchant-location',
                title: 'Locations',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null,
                component: () => import( '../components/merchant/SelectLocation' ),
            },
            {
                path: 'merchantDelivery',
                name: 'merchant-delivery',
                title: 'Delivery or Pickup',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null,
                component: () => import( '../components/merchant/SelectDelivery' ),
            },
            {
                path: 'deliveryPickup',
                name: 'delivery-pickup-spot',
                title: 'Select Spot',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null,
                component: () => import( '../components/merchant/DeliveryPickupSpot' ),
            },
            {
                path: 'deliveryBuilding',
                name: 'delivery-building',
                title: 'Add Details',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null,
                component: () => import( '../components/merchant/DeliveryBuilding' ),
            },
            {
                path: 'fullDelivery',
                name: 'full-delivery',
                title: 'Add Your Address',
                onFooter: false,
                onOverflow: false,
                displaySequence: 0,
                icon: null,
                component: () => import( '../components/merchant/FullDelivery' ),
            },
            {
                path: 'payment',
                // component: OrderMenu,
                name: 'payment',
                title: 'Payment',
                onFooter: false,
                onOverflow: false,
                displaySequence: null,
                icon: null,
                component: () => import( '../components/order/Payment' ),
            },
            {
                path: 'paymentCard',
                // component: OrderMenu,
                name: 'payment-card',
                title: 'Payment',
                onFooter: false,
                onOverflow: false,
                displaySequence: null,
                icon: null,
                component: () => import( '../components/order/PaymentCard' ),
            },
            {
                path: 'orderPromotionCard',
                // component: OrderMenu,
                name: 'order-promotion-card',
                title: 'Bonus Cards',
                onFooter: false,
                onOverflow: false,
                displaySequence: null,
                icon: null,
                component: () => import('../components/order/OrderPromotionCard'),
            }
        ]
    },
    {
        path: '*',
        redirect: '/m/merchants'
    }
];
